<template>
  <tr>
    <td class="name">
      {{ item.role_name }}
    </td>
    <template v-for="(item, itemKey) in abilitiesCheck">
      <td v-for="(param, paramKey) in item.params" :key="itemKey + '_' + paramKey" class="role">
        <v-tooltip bottom color="#2C2C2C">
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="icons d-flex" id="users">
              <Viewing v-if="param.accesses.view === undefined ? true : param.accesses.view" />
              <NoAccess v-else-if="param.accesses.no_access" />
              <Editing v-if="param.accesses.edit" />
              <Add v-if="param.accesses.add" />
              <Remove v-if="param.accesses.remove" />
              <Blocked v-if="param.accesses.block" />
            </div>
          </template>
          <span>{{ item.title + ' - ' + param.name }}</span>
        </v-tooltip>
      </td>
    </template>
    <td>
      <div class="buttons" v-if="$userCheckAccess({ abilities: 'edit_roles' })">
        <EditBtn :toName="'SettingRolesUpdate'" :id="item.id" />
        <DeleteModal
          :item="item"
          :text="
            localStorage.translations.pages['setting-roles']['dialog_delete']['udalit-rol'] +
            ' ' +
            item.role_name
          "
          :textSecond="
            localStorage.translations.pages['setting-roles']['dialog_delete'][
              'dlya-udaleniya-roli'
            ] +
            ' ' +
            item.role_name +
            ' ' +
            localStorage.translations.pages['setting-roles']['dialog_delete'][
              'neobhodimo-udalit-svyazi'
            ]
          "
          :textCheckbox="localStorage.translations.pages.common.checkbox.delete_all_links"
        />
      </div>
    </td>
  </tr>
</template>

<script>
import EditBtn from 'components/EditBtn'
import DeleteModal from 'components/DeleteModal'
import _ from 'lodash'
import Blocked from 'components/icons/rolesTable/Blocked'
import Editing from 'components/icons/rolesTable/Editing'
import NoAccess from 'components/icons/rolesTable/NoAccess'
import Remove from 'components/icons/rolesTable/Remove'
import Viewing from 'components/icons/rolesTable/Viewing'
import Add from 'components/icons/rolesTable/Add'

export default {
  name: 'RolesTableItem',
  props: ['item', 'tableItems'],
  components: {
    EditBtn,
    DeleteModal,
    Blocked,
    Editing,
    NoAccess,
    Remove,
    Viewing,
    Add,
  },
  data: () => ({
    abilitiesName: [],
  }),
  computed: {
    abilities() {
      return this.item.abilities
    },
    abilitiesCheck() {
      let result = _.cloneDeep(this.tableItems)
      for (let tableItemKey in result) {
        const tableItem = result[tableItemKey]
        for (let paramKey in tableItem.params) {
          const paramItem = tableItem.params[paramKey]
          this.$delete(paramItem, 'list')
          for (let accessKey in paramItem.accesses) {
            paramItem.accesses[accessKey] = this.checkAbilityType({ paramItem, accessKey })
          }
          paramItem.accesses.no_access = Object.keys(paramItem.accesses).every(
            (i) => i !== 'no_access' && paramItem.accesses[i] === false,
          )
        }
      }
      return result
    },
  },

  watch: {
    abilities() {
      return this.onAbilitiesName()
    },
  },

  created() {
    this.onAbilitiesName()
  },

  methods: {
    checkAbilityType({ paramItem, accessKey }) {
      const checkItem = paramItem.accesses[accessKey]
      if (typeof checkItem === 'object') {
        return this.includesAll(this.abilitiesName, checkItem)
      } else if (typeof checkItem === 'string') {
        return this.checkAbilityType({ paramItem, accessKey: checkItem })
      } else if (checkItem === true || checkItem === false) {
        return checkItem
      }
    },
    onAbilitiesName() {
      let abilitiesName = []
      for (let i = 0; i < this.item.abilities.length; i++) {
        abilitiesName.push(this.item.abilities[i].ability_name)
      }
      this.abilitiesName = [...new Set(abilitiesName)]
    },
    includesAll(arr, values) {
      // console.log('includesAll', { arr, values })
      try {
        if (arr.length) {
          return values.every((v) => arr.includes(v))
        }
      } catch (e) {
        return e
      }
    },
  },
}
</script>

<style lang="scss" scoped>
td {
  justify-content: end;

  &:before {
    max-width: 80%;
  }

  .icons {
    gap: 8px;
    flex-wrap: wrap;
  }
}
</style>
